import {isEmpty} from 'lodash'
import {filter, negate, pipe} from 'lodash/fp'
import * as React from 'react'
import * as Flash from './flash'
import './styles.css'

export const showNotificationArea = pipe(
  filter(Boolean),
  negate(isEmpty),
)

export const Notifications = () => <div className="notification-area">
  <Flash.FlashMessage/>
</div>
